export enum SituacionsEnLesQueEncaixes {
    None = "None",
    Conductor = "Conductor",
    ServeisTransport = "ServeisTransport",
    Client = "Client",
    Proveidor = "Proveidor",
    FreightForwarder = "FreightForwarder",
    Slots = "Slots",
    Other = "Other"
}